import './App.css';
import { useLocation } from 'react-router-dom';
import { BUYMATERIAL, LOGIN, OTP, SELECT } from './Routes/constURL';
import Sidebar from './Components/Sidebar';
import Footer2 from './Components/Footer2';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Index from './Routes'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { generateSessionToken } from './Config/Util';

function App() {
  const location = useLocation()
  
  useEffect(() => {
    // Check if a session token already exists in sessionStorage
    if (!sessionStorage.getItem('session')) {
      generateSessionToken(); // Generate a new session token
    }
  }, []);
  
  const theme = createTheme({
    typography: {
      fontFamily: "'Aller', sans-serif",
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <Header />
        <Box sx={{display: location.pathname === BUYMATERIAL&& "flex"}}>
          {location.pathname === BUYMATERIAL
            && <Sidebar />}
          <Index />
        </Box>

        {location.pathname !== LOGIN && location.pathname !== OTP && location.pathname !== SELECT ? <Footer /> : <Footer2 />}
      </ThemeProvider>
    </>
  );
}

export default App;
